export const SUPPORTED_TOKENS = [
  {
    symbol: 'ETH',
    name: 'Ethereum',
    address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    decimals: 18,
    logo: 'https://cryptologos.cc/logos/ethereum-eth-logo.png'
  },
  {
    symbol: 'USDT',
    name: 'Tether USD',
    address: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    decimals: 6,
    logo: 'https://cryptologos.cc/logos/tether-usdt-logo.png'
  },
  {
    symbol: 'USDC',
    name: 'USD Coin',
    address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    decimals: 6,
    logo: 'https://cryptologos.cc/logos/usd-coin-usdc-logo.png'
  },
  {
    symbol: 'DAI',
    name: 'Dai Stablecoin',
    address: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
    decimals: 18,
    logo: 'https://cryptologos.cc/logos/multi-collateral-dai-dai-logo.png'
  },
  {
    symbol: 'WETH',
    name: 'Wrapped Ether',
    address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    decimals: 18,
    logo: 'https://cryptologos.cc/logos/ethereum-eth-logo.png'
  }
];

export const STAKING_POOLS = [
  {
    id: 'eth-pool',
    name: 'ETH Staking',
    token: 'ETH',
    apy: 4.2,
    tvl: '1.2B',
    minStake: 0.1
  },
  {
    id: 'usdc-pool',
    name: 'USDC Pool',
    token: 'USDC',
    apy: 8.5,
    tvl: '850M',
    minStake: 100
  },
  {
    id: 'dai-pool',
    name: 'DAI Pool',
    token: 'DAI',
    apy: 7.8,
    tvl: '420M',
    minStake: 100
  }
];

export const FARMING_POOLS = [
  {
    id: 'eth-usdc',
    name: 'ETH-USDC LP',
    tokens: ['ETH', 'USDC'],
    apy: 15.2,
    tvl: '2.1B'
  },
  {
    id: 'eth-dai',
    name: 'ETH-DAI LP',
    tokens: ['ETH', 'DAI'],
    apy: 12.8,
    tvl: '890M'
  },
  {
    id: 'usdc-dai',
    name: 'USDC-DAI LP',
    tokens: ['USDC', 'DAI'],
    apy: 9.5,
    tvl: '650M'
  }
];

export const FIAT_PACKAGES = [
  {
    id: 'starter',
    label: 'Starter',
    amount: 50,
    bonus: 0,
    popular: false
  },
  {
    id: 'pro',
    label: 'Pro',
    amount: 100,
    bonus: 5,
    popular: true
  },
  {
    id: 'premium',
    label: 'Premium',
    amount: 250,
    bonus: 15,
    popular: false
  },
  {
    id: 'enterprise',
    label: 'Enterprise',
    amount: 500,
    bonus: 35,
    popular: false
  }
];